<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col
        lg="12"
        style="display:block; text-align:center;padding-bottom:15px;font-size:1.2em;"
        v-if="total>0" >
        <span style="padding:5px;">Total Records:</span>
        <b style="border-right:1px solid white; padding-right:5px;">{{total}}</b>
        <span style="padding:5px;">Total Price:</span>
        <b>${{totalPrice.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}</b>

        <b-button
          class="download-button"
          variant="primary"
          size="lg"
          @click="downloadExcel();"
        >
          <div style="display:inline-block;" v-if="loading2019" class="loading">
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce bouncing2">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>

          <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>
          Download
        </b-button>

      </b-col>
      <b-col lg="12">
        <c-table :table-data="data" :fields="fields" :caption="title"></c-table>
        <div v-show="loading" class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cTable from "./Table.vue";

export default {
  props: [
    "location",
    "productGroup",
    "type",
    "date_from",
    "date_to",
    "productModel",
    "prg",
    "clients",
    "failure",
    "fns_part",
    "client",
    "city"
  ],
  name: "tables",
  components: { cTable },
  data: () => {
    return {
      locationParam: "",
      excelDownload: "",
      loading2019: false,
      loadingExcel: false,
      clientsId: "",
      productGroupParam: "",
      dateFromParam: "",
      modelParam: "",
      dateToParam: "",
      title: "",
      loading: true,
      data: [],
      total: 0,
      totalPrice: 0,
      fields: [
        { key: "fnsid", label: "FNSID", sortable: true },
        { key: "locat", label: "Location" },
        { key: "sernm", label: "Serial#" },
        {
          key: "pMake",
          label: "Manufacturer",
          sortable: true,
          style: "width: 250px"
        },
        { key: "pMode", label: "Model" },
        {
          key: "compl",
          label: "Complaint",
          sortable: true,
          tdClass: "complaintClass"
        },
        { key: "loctn", label: "Status", sortable: true },
        { key: "price", label: "Price", sortable: true }
      ]
    };
  },
  methods: {
    downloadExcel() {
      this.loading2019 = true;
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        prodModel: this.modelParam,
        fns_part: this.fns_part,
        failure: this.failure,
        xml: "true",
      };
      this.$http
        .get(this.excelDownload, {
          params,
          responseType: "blob"
        })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TableReport.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loading2019 = false;
          },
          err => {
            this.loading2019 = false;
            console.log(err);
          }
        );
    },
    fetchChartDataReceived() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.$http
        .get("api/commscope/tables/recieved.php", { params })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });
            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataShipped() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        prodModel: this.modelParam,
        client: this.city
      };

      let shippedUrl = this.city ? "api/commscope/tables/shipped_city.php" : "api/commscope/tables/shipped.php";

      this.$http
        .get(shippedUrl, { params })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataCityPerGroup() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.prg,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.$http
        .get("api/commscope/tables/shipped.php", { params })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataBer() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        prodModel: this.modelParam
      };
      this.$http
        .get("api/commscope/tables/ber.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });
            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataEol() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.$http
        .get("api/commscope/tables/eol.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });
            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataNtf() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.$http
        .get("api/commscope/tables/ntf.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataWar() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.$http
        .get("api/commscope/tables/war.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataOem() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam
      };
      this.$http
        .get("api/commscope/tables/oem_backlog.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataOemShipped() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.$http
        .get("api/commscope/tables/oem_delivered.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDatabacklog() {
      let params = {};

      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        prodModel: this.modelParam,
        client: this.city
      };

      let backlogUrl = this.city ? "api/commscope/tables/back_city.php" : "api/commscope/tables/back.php";

      this.$http
        .get(backlogUrl, {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
            console.log(this.$refs);
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchSubBacklog() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam
      };
      this.$http
        .get("api/commscope/tables/subdivision_backlog.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchSubDelivered() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.$http
        .get("api/commscope/tables/subdivision_delivered.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataPart() {
      let params = {};
      params = {
        fns_part: this.fns_part,
        failure: this.failure,
      };
      this.$http
        .get("api/commscope/tables/failureDataByPart.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataDesignator(){
      let params = {};
      params = {
        fns_part: this.fns_part,
        failure: this.failure,
      };
      this.$http
        .get("api/commscope/tables/failureDataByDesignator.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataFailure(){
      let params = {};
      params = {
        fns_part: this.fns_part,
        failure: this.failure,
      };
      this.$http
        .get("api/commscope/tables/failureDataByFailure.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataComplaint(){
      let params = {};
      params = {
        fns_part: this.fns_part,
        failure: this.failure,
      };
      this.$http
        .get("api/commscope/tables/failureDataByComplaint.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    }
  },
  watch : {
    data: function () {
      this.loading = false;
      if (this.data===undefined){
        this.title = "No data found"
      }
    }
  },
  mounted() {

    if (this.type != "top") {
      if (this.location){
        this.locationParam = this.location.substring(
          0,
          this.location.lastIndexOf("(")
        );
      }
      if (this.productGroup){
        this.productGroupParam = this.productGroup.substring(
          0,
          this.productGroup.lastIndexOf("(")
        );
      }


      if(this.productModel) {
        this.modelParam = this.productModel.substring(
          0,
          this.productModel.lastIndexOf("(")
        );
      }

      this.title =
        this.type.toLocaleUpperCase() +
        " - " +
        this.productGroupParam +
        " in " +
        this.locationParam;
    } else {
      this.locationParam = this.location;
      this.productGroupParam = this.prg.substring(0, this.prg.lastIndexOf("("));
      this.title = this.prg + " Shipped to " + this.locationParam;
    }
    this.clientsId = this.clients;
    this.dateFromParam = this.date_from;
    this.dateToParam = this.date_to;
    if (this.type === "Received") {
      this.fetchChartDataReceived();
      this.excelDownload = "api/commscope/tables/recieved.php";
    }
    if (this.type === "Shipped"|| this.type==='shipped') {
      this.fetchChartDataShipped();
      this.excelDownload = this.city ? "api/commscope/tables/shipped_city.php" : "api/commscope/tables/shipped.php";
    }
    if (this.type === "top") {
      this.fetchChartDataShipped();
      this.excelDownload = "api/commscope/tables/shipped.php";
    }
    if (this.type === "OEM") {
      this.fetchChartDataOem();
      this.excelDownload = "api/commscope/tables/oem_backlog.php";
    }
    if (this.type === "OEMShip") {
      this.fetchChartDataOemShipped();
      this.excelDownload = "api/commscope/tables/oem_delivered.php";
    }
    if (this.type === "ber"|| this.type=== 'BER') {
      this.fetchChartDataBer();
      this.excelDownload = "api/commscope/tables/ber.php";
    }
    if (this.type === "eol") {
      this.fetchChartDataEol();
      this.excelDownload = "api/commscope/tables/eol.php";
    }
    if (this.type === "ntf") {
      this.fetchChartDataNtf();
      this.excelDownload = "api/commscope/tables/ntf.php";
    }
    if (this.type === "war") {
      this.fetchChartDataWar();
      this.excelDownload = "api/commscope/tables/war.php";
    }
    if (this.type === "backlog") {
      this.fetchChartDatabacklog();
      this.excelDownload = this.city ? "api/commscope/tables/back_city.php" : "api/commscope/tables/back.php";
    }
    if (this.type === "city") {
      this.fetchChartDataCityPerGroup();
      this.excelDownload = "api/commscope/tables/shipped.php";
    }
    if (this.type === "SubDivisionBacklog") {
      this.fetchSubBacklog();
      this.excelDownload = "api/commscope/tables/subdivision_backlog.php";
    }
    if (this.type === "SubDivisionDelivered") {
      this.fetchSubDelivered();
      this.excelDownload = "api/commscope/tables/subdivision_delivered.php";
    }
    let typeSplit = this.type.split("(");
    if (typeSplit[0] === 'Part') {
      this.title = "Failure by Part";
      this.fetchChartDataPart();
      this.excelDownload = "api/commscope/tables/failureDataByPart.php";
    }
    if (typeSplit[0] === 'Designator') {
      this.title = "Failure by Designator";
      this.fetchChartDataDesignator();
      this.excelDownload = "api/commscope/tables/failureDataByDesignator.php";
    }
    if (typeSplit[0] === 'Failure') {
      this.title = "Failure by Failure";
      this.fetchChartDataFailure();
      this.excelDownload = "api/commscope/tables/failureDataByFailure.php";
    }
    if (typeSplit[0] === 'Complaint') {
      this.title = "Failure by Complaint";
      this.fetchChartDataComplaint();
      this.excelDownload = "api/commscope/tables/failureDataByComplaint.php";
    }

  }
};
</script>
<style>
.complaintClass {
  width: 200px;
}

.download-button {
  display: inline-block;
  margin: auto;
  float: right;
  font-weight: 500;
  padding: 0.7em;
  font-size: 0.9em;
  border-radius: 0.3rem;
  color: white;
  background: #20a8d8;
}

.bouncing2 {
  height: 20px !important;
  width: 20px !important;
  line-height: 55px;
  margin: auto;
}

.download-button:hover {
  text-decoration: none !important;
  color: white;
}

.fa-file-excel-o {
  font-size: 1em;
  color: #ffffff68;
  transform: rotate(30deg);
  padding-right: 0.5em;
}
</style>
